import { render } from "./IconCross.vue?vue&type=template&id=5584a45a"
import script from "./IconCross.vue?vue&type=script&lang=js"
export * from "./IconCross.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/assets/js/components/Icons/Icons/24/IconCross.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5584a45a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5584a45a', __exports__)) {
    api.reload('5584a45a', __exports__)
  }
  
  module.hot.accept("./IconCross.vue?vue&type=template&id=5584a45a", () => {
    api.rerender('5584a45a', render)
  })

}


export default __exports__